import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import "./css/Stars.css";
import Earth from "./Earth";
import { locationInfoAtom } from "./AtomWithDynamoDB";
import ReceptionErrorModal from "./components/modal/ReceptionErrorModal";
import { ROUTE } from "~/constants/routes";

const Home: React.FC = () => {
  // locationInfoAtomを参照させてDynamoDB初期化を確実にトリガーさせる
  // eslint-disable-next-line
  const [_locationInfo] = useAtom(locationInfoAtom);
  const navigate = useNavigate();
  const [showReceptionErrorModal, setShowReceptionErrorModal] = React.useState(false);
  const handleReceptionClick = () => {
    navigate(ROUTE.RECEPTION.LOADING, { state: { skipStartupModal: true } });
  };

  return (
    <div className="home-container">
      {/*{generateStars(100)} /!* 星を100個描画 *!/*/}
      <Earth />
      <h1>ホームページ</h1>
      <Link to="/chat">
        <button className="navigate-button">チャットページに移動</button>
      </Link>
      <button className="navigate-button" onClick={handleReceptionClick}>
        受付ページに移動
      </button>
      <Link to="/knowledge">
        <button className="navigate-button">ナレッジジェネレータ</button>
      </Link>
      <Link to="/googlemap">
        <button className="navigate-button">GoogleMap</button>
      </Link>
      <Link to="/analytics">
        <button className="navigate-button">会話履歴統計</button>
      </Link>
      <Link to="/setting">
        <button className="navigate-button">管理画面</button>
      </Link>

      <ReceptionErrorModal
        isOpen={showReceptionErrorModal}
        onClose={() => setShowReceptionErrorModal(false)}
      />
      <Link to="/healthcheck">
        <button className="navigate-button">死活監視</button>
      </Link>
      <Link to="/dify-api-test">
        <button className="navigate-button">Dify API テスト画面</button>
      </Link>
    </div>
  );
};

export default Home;
